import { render, staticRenderFns } from "./PresentationCard.vue?vue&type=template&id=47022079&scoped=true&"
import script from "./PresentationCard.vue?vue&type=script&lang=js&"
export * from "./PresentationCard.vue?vue&type=script&lang=js&"
import style0 from "./PresentationCard.vue?vue&type=style&index=0&id=47022079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47022079",
  null
  
)

export default component.exports